import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { Heart, X } from "lucide-react";
import { api } from "../lib/api";
import Layout from "../components/Layout";

export default function Sponsor() {
  const [children, setChildren] = useState([]);
  const [sel, setSel] = useState(null);
  const [form, setForm] = useState({ sponsor_name:"", sponsor_email:"", amount:30, message:"" });
  const [loading, setLoading] = useState(false);
  useEffect(() => { api.get("/children").then(r => setChildren(r.data||[])).catch(()=>{}); }, []);
  const set = (k,v) => setForm(s=>({...s,[k]:v}));
  const submit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await api.post("/sponsorships", { ...form, child_id: sel.id, amount: Number(form.amount) }); toast.success("Merci ! Votre parrainage est enregistré."); setSel(null); setForm({sponsor_name:"",sponsor_email:"",amount:30,message:""}); }
    catch { toast.error("Erreur"); } finally { setLoading(false); }
  };
  return (
    <Layout>
      <div data-testid="sponsor-page">
        <section className="hero-gradient py-24">
          <div className="max-w-6xl mx-auto px-5 lg:px-10">
            <div className="text-xs uppercase tracking-[0.3em] text-warm-orange font-semibold">Parrainage</div>
            <h1 className="font-display text-deep-blue text-5xl sm:text-6xl lg:text-7xl leading-tight mt-3">Parrainez<br/><span className="italic text-warm-orange">un enfant.</span></h1>
            <p className="text-deep-blue/70 mt-6 max-w-2xl">Un lien direct, un suivi personnalisé, un impact tangible sur la vie d'un enfant. Chaque parrainage finance l'éducation, l'alimentation et l'accompagnement.</p>
          </div>
        </section>
        <section className="py-16 bg-ivory">
          <div className="max-w-6xl mx-auto px-5 lg:px-10">
            {children.length === 0 ? (
              <div className="p-12 rounded-2xl bg-pearl text-center">
                <p className="font-display text-2xl text-deep-blue">Les premiers enfants à parrainer seront publiés ici prochainement.</p>
                <p className="text-deep-blue/60 mt-2">Ce dispositif est mis en place dans un cadre juridiquement approprié, avec l'accord des familles et des services compétents.</p>
              </div>
            ) : (
              <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
                {children.map(c => (
                  <div key={c.id} className="card-elev rounded-2xl overflow-hidden" data-testid={`child-${c.id}`}>
                    {c.photo ? <img src={c.photo} alt={c.first_name} className="w-full h-56 object-cover"/> : <div className="w-full h-56 bg-gradient-to-br from-warm-orange to-gold grid place-items-center font-display text-6xl text-deep-blue">{c.first_name?.charAt(0)}</div>}
                    <div className="p-6">
                      <div className="flex items-center justify-between">
                        <h3 className="font-display text-2xl text-deep-blue">{c.first_name}</h3>
                        <span className="text-xs px-2 py-1 rounded-full bg-gold/20 text-deep-blue">{c.age} ans</span>
                      </div>
                      <div className="text-xs uppercase tracking-widest text-warm-orange mt-1">{c.location || "—"}</div>
                      <p className="text-sm text-deep-blue/70 mt-3 line-clamp-4">{c.story}</p>
                      <div className="mt-4 flex items-center justify-between">
                        <span className="font-display text-xl text-deep-blue">dès {c.monthly_amount || 30}€/mois</span>
                        <button onClick={()=>{setSel(c);setForm(s=>({...s, amount: c.monthly_amount||30}));}} className="btn-gold px-4 py-2 rounded-full text-sm font-semibold inline-flex items-center gap-1" data-testid={`sponsor-btn-${c.id}`}><Heart size={14}/> Parrainer</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </section>
        {sel && (
          <div className="fixed inset-0 z-[60] bg-deep-blue/95 grid place-items-center p-5" onClick={()=>setSel(null)} data-testid="sponsor-modal">
            <form onSubmit={submit} onClick={e=>e.stopPropagation()} className="bg-ivory rounded-2xl p-8 w-full max-w-lg space-y-3 relative">
              <button type="button" onClick={()=>setSel(null)} className="absolute top-3 right-3 w-9 h-9 rounded-full bg-pearl grid place-items-center"><X size={16}/></button>
              <div className="text-xs uppercase tracking-widest text-warm-orange">Parrainage de {sel.first_name}</div>
              <h2 className="font-display text-3xl text-deep-blue">Je m'engage.</h2>
              <input required placeholder="Nom complet" value={form.sponsor_name} onChange={e=>set("sponsor_name",e.target.value)} className="w-full p-3 rounded-lg border-2 border-black/5 focus:border-gold outline-none" data-testid="sp-name"/>
              <input required type="email" placeholder="Email" value={form.sponsor_email} onChange={e=>set("sponsor_email",e.target.value)} className="w-full p-3 rounded-lg border-2 border-black/5 focus:border-gold outline-none" data-testid="sp-email"/>
              <div>
                <div className="text-xs text-deep-blue/60 mb-1">Montant mensuel (€)</div>
                <input required type="number" min="5" value={form.amount} onChange={e=>set("amount",e.target.value)} className="w-full p-3 rounded-lg border-2 border-black/5 focus:border-gold outline-none" data-testid="sp-amount"/>
              </div>
              <textarea rows={3} placeholder="Message (optionnel)" value={form.message} onChange={e=>set("message",e.target.value)} className="w-full p-3 rounded-lg border-2 border-black/5 focus:border-gold outline-none" data-testid="sp-message"/>
              <button disabled={loading} className="btn-gold w-full py-3 rounded-full font-semibold" data-testid="sp-submit">{loading?"Envoi…":"Confirmer mon parrainage"}</button>
              <p className="text-xs text-deep-blue/60 italic">Vous recevrez par email les modalités de paiement et le suivi personnalisé de {sel.first_name}.</p>
            </form>
          </div>
        )}
      </div>
    </Layout>
  );
}
